import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './fonts/brandon/Brandon-medium.otf'
import './fonts/brandon/Brandon-regular.otf'
import App from './App'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
